import Collapsible from "./collapsible.component.js";

export default angular
    .module("oui.collapsible", [])
    .component("ouiCollapsible", Collapsible)
    .name;
